var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598,
    height: 629,
    viewBox: "0 0 598 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 71.5C422 85.0001 361.121 137.499 527 157C567.5 161.761 653.498 204.481 543 451.5C405 760 186.29 583.554 135 524.5C-3.54054 364.988 -81.5969 61.3116 135 71.5Z",
    fill: "#ECCDCB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349 32C349 14.3 334.7 0 317 0C299.3 0 285 14.3 285 32V288C285 305.7 299.3 320 317 320C334.7 320 349 305.7 349 288V32ZM317 448C327.609 448 337.783 443.786 345.284 436.284C352.786 428.783 357 418.609 357 408C357 397.391 352.786 387.217 345.284 379.716C337.783 372.214 327.609 368 317 368C306.391 368 296.217 372.214 288.716 379.716C281.214 387.217 277 397.391 277 408C277 418.609 281.214 428.783 288.716 436.284C296.217 443.786 306.391 448 317 448Z",
    fill: "#823434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 448,
    fill: "white",
    transform: "translate(277)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.499bc11409d4b5190e1c624de0b8d322.svg";
export { ForwardRef as ReactComponent };